import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";

const MemberPricingPage: React.FC = () => {
  const [selectedCountry, setSelectedCountry] = useState<string>("kenya");
  const [activeTab, setActiveTab] = useState<string>("first");

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.flutterwave.com/v3.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const showPrice = (country: string) => {
    setSelectedCountry(country);
  };

  const showStyle = (style: string) => {
    setActiveTab(style);
  };

  const makePayment = (
    txRef: string,
    amount: number,
    currency: string,
    page: string,
  ) => {
    const enterEmail = window.prompt("Please Enter email:");
    if (enterEmail && (window as any).FlutterwaveCheckout) {
      (window as any).FlutterwaveCheckout({
        public_key: "FLWPUBK-5f6838a7c0e57abef40cddf34c449086-X",
        tx_ref: txRef,
        amount,
        currency,
        payment_options: "card, banktransfer, ussd",
        redirect_url: `https://stemcafe.io/${page}.html`,
        customer: {
          email: enterEmail,
        },
      });
    }
  };

  return (
    <div>
      <div className="membership p60">
        <div className="container">
          <div className="container">
            <div className="page-header">
              <h2>Become a Member</h2>
              <p>
                Choose a membership plan to get access to all amazing activities
                available and other great benefits.
              </p>

              <div className="row head">
                <div className="col-sm-5">
                  <p>Showing membership packages for</p>
                </div>
                <div className="col-sm-7">
                  <button
                    onClick={() => {
                      showStyle("first");
                      showPrice("kenya");
                    }}
                    id="first"
                    className={activeTab === "first" ? "active" : "unactive"}
                  >
                    Kenya
                  </button>
                  <button
                    onClick={() => {
                      showStyle("second");
                      showPrice("rwanda");
                    }}
                    id="second"
                    className={activeTab === "second" ? "active" : "unactive"}
                  >
                    Rwanda
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Rwanda Pricing */}
          {selectedCountry === "rwanda" && (
            <div id="rwanda" className="select-plan">
              <div className="plan">
                <div className="plan-details">
                  <ul>
                    <li>Individual membership (1 kid)</li>
                    <li className="cost">
                      RWF 13,000<span>/year</span>
                    </li>
                    <li className="purchase">
                      <button
                        type="button"
                        id="start-payment-button"
                        onClick={() =>
                          makePayment(
                            "Individual Membership",
                            13000,
                            "RWF",
                            "membership",
                          )
                        }
                      >
                        Get membership
                      </button>
                    </li>
                  </ul>
                  <ul>
                    <li>Family membership (3 to 4 kids)</li>
                    <li className="cost">
                      RWF 46,800<span>/year</span>
                    </li>
                    <li className="purchase">
                      <button
                        type="button"
                        id="start-payment-button"
                        onClick={() =>
                          makePayment(
                            "Family Membership",
                            46800,
                            "RWF",
                            "membership",
                          )
                        }
                      >
                        Get membership
                      </button>
                    </li>
                    <li>
                      Kindly note that membership does not include activities
                    </li>
                  </ul>
                </div>
                <div className="plan-benefits">
                  <ul id="tick">
                    <li>
                      <b>Discount:</b> 10% discount on monthly plans & packages
                    </li>
                    <li>
                      <b>Rewards program:</b> Members gain Automatic enrolment
                      in STEMCafe Rewards Program where points are accrued.
                    </li>
                    <li>
                      <b>Early access:</b> Members will be able to test new
                      games before general release date
                    </li>
                    <li>
                      <b>Challenges:</b> Members will be part of internal
                      challenges set up to keep members thinking, tinkering, and
                      testing
                    </li>
                    <li>
                      <b>Exhibitions:</b> Enrolment in quarterly exhibitions to
                      showcase completed projects
                    </li>
                    <li>
                      <b>Competitions:</b> Access to information on
                      international STEM competitions and enrolment support will
                      also be provided.
                    </li>
                    <li>
                      <b>Birthday Programs:</b> Special projects created for
                      celebrants to play and learn with their friends, will
                      include Virtual reality content. Celebrants can also bring
                      up to 2 friends for a free 1-hour session.
                    </li>
                    <li>
                      <b>STEMCafe merchandise:</b> access to discounted or
                      branded STEMCafe items
                    </li>
                  </ul>
                </div>
              </div>

              <div className="plan">
                <div className="plan-details">
                  <ul>
                    <li className="cost">Pay as you go</li>
                  </ul>
                </div>
                <div className="plan-benefits">
                  <ul id="tick">
                    <li>Walk-in fee of RWF 18,500/hour</li>
                    <li>No membership fee required</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Kenya Pricing */}
          {selectedCountry === "kenya" && (
            <div id="kenya" className="select-plan">
              <div className="plan">
                <div className="plan-details">
                  <ul>
                    <li>Individual membership (1 kid)</li>
                    <li className="cost">
                      KES 1,500<span>/year</span>
                    </li>
                    <li className="purchase">
                      <button
                        type="button"
                        id="start-payment-button"
                        onClick={() =>
                          makePayment(
                            "Individual Membership",
                            1500,
                            "KES",
                            "membership",
                          )
                        }
                      >
                        Get membership
                      </button>
                    </li>
                  </ul>

                  <ul>
                    <li>Family membership (3 to 4 kids)</li>
                    <li className="cost">
                      KES 4,500<span>/year</span>
                    </li>
                    <li className="purchase">
                      <button
                        type="button"
                        id="start-payment-button"
                        onClick={() =>
                          makePayment(
                            "Family Membership",
                            4500,
                            "KES",
                            "membership",
                          )
                        }
                      >
                        Get membership
                      </button>
                    </li>
                    <li>
                      Kindly note that membership does not include activities
                    </li>
                  </ul>
                </div>
                <div className="plan-benefits">
                  <ul id="tick">
                    <li>
                      <b>Discount:</b> 10% discount on monthly plans & packages
                    </li>
                    <li>
                      <b>Rewards program:</b> Members gain Automatic enrolment
                      in STEMCafe Rewards Program where points are accrued.
                    </li>
                    <li>
                      <b>Early access:</b> Members will be able to test new
                      games before general release date
                    </li>
                    <li>
                      <b>Challenges:</b> Members will be part of internal
                      challenges set up to keep members thinking, tinkering, and
                      testing
                    </li>
                    <li>
                      <b>Exhibitions:</b> Enrolment in quarterly exhibitions to
                      showcase completed projects
                    </li>
                    <li>
                      <b>Competitions:</b> Access to information on
                      international STEM competitions and enrolment support will
                      also be provided.
                    </li>
                    <li>
                      <b>Birthday Programs:</b> Special projects created for
                      celebrants to play and learn with their friends, will
                      include Virtual reality content. Celebrants can also bring
                      up to 2 friends for a free 1-hour session.
                    </li>
                    <li>
                      <b>STEMCafe merchandise:</b> access to discounted or
                      branded STEMCafe items
                    </li>
                  </ul>
                </div>
              </div>

              <div className="plan">
                <div className="plan-details">
                  <ul>
                    <li className="cost">Pay as you go</li>
                  </ul>
                </div>
                <div className="plan-benefits">
                  <ul id="tick">
                    <li>Walk-in fee of KES 1,000/hour</li>
                    <li>No membership fee required</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MemberPricingPage;
